import axios, { AxiosRequestConfig } from 'axios';
import { useToken } from '../contexts/tokenContext';
import { Group } from '../entities/Group';

export const useCreateGroup = () => {
	const token = useToken();
	return async (form: any): Promise<Group | null> => {
		try {
			if (!token?.accessToken) {
				return null;
			}

			const params: AxiosRequestConfig = {
				method: 'POST',
				url: '/groups',
				data: form,
				withCredentials: true,
			};
			const result = await axios.request(params);
			return result.data;
		} catch (error) {
			throw error;
		}
	};
};
